import { Box } from "@mui/material";
import React from "react";

const IMAGE_URIS: Record<string, string> = {
  audio: "/images/audio.png",
  audioButtonGroup: "/images/audio.png",
  contentDocument: "/images/file.png",
  externalApp: "/images/game.png",
  gallery: "/images/image.png",
  game: "/images/game.png",
  richText: "/images/text.png",
  text: "/images/text.png",
  video: "/images/video.png",
  website: "/images/website.png",
  youtube: "/images/youtube.png",
  moderationCard: "/images/text.png",
  navigation: "/images/navigation.png",
};

const getKindImage = (kind: string): string => IMAGE_URIS[kind] ?? "";

type ContentKindIconProps = {
  contentKind: string;
  size?: number;
};

export const ContentKindIcon: React.FC<ContentKindIconProps> = ({ contentKind, size = 24 }) => {
  const iconSrc = getKindImage(contentKind);

  if (!iconSrc) {
    return null;
  }

  return (
    <Box
      component="img"
      src={iconSrc}
      alt={`${contentKind} content`}
      width={size}
      height={size}
      sx={{ display: "inline-block", verticalAlign: "middle" }}
    />
  );
};
